export default "__VITE_ASSET__DDz5AmkT__"